const HttpMethod = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  PATH: 'PATCH',
  DELETE: 'DELETE',
}

export { HttpMethod }
